/* Actions */
import { ACTION_TYPES_BASE_NAME } from "./actions";

/* Others */
import { makeFetchReducers } from "../../utils";

const reducers = makeFetchReducers(ACTION_TYPES_BASE_NAME);

export default reducers;
